import produce from 'immer';
import { STORED_POWER_LOG_LIST_REQUEST } from '../../constants/log/storedPowerLogConstants';

const initialState = {

};

const storedPowerLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case STORED_POWER_LOG_LIST_REQUEST:
      break;
    default:
      break;
  }
});

export default storedPowerLogReducer;
